/**
 * Created by jrnoguero on 31/03/2025.
 */
angular
    .module('annexaApp')
    .component('annexaDocumentSignAssistent', {
    	templateUrl: './components/doc/annexa-document-assistent/annexa-document-assistent.html',
        controller: ['$rootScope', 'DccumentsFactory', 'BoxFactory', 'globalModals', 'AnnexaFormlyFactory', 'Upload', '$state', '$scope', 'SignLocalFactory', '$filter', 'GlobalDataFactory', 'AnnexaPermissionsFactory', 'Language', 'HelperService','DialogsFactory', 'SignService', 'apiSign',
            function($rootScope, DccumentsFactory, BoxFactory, globalModals, AnnexaFormlyFactory, Upload, $state, $scope, SignLocalFactory, $filter, GlobalDataFactory, AnnexaPermissionsFactory, Language, HelperService,DialogsFactory, SignService, apiSign) {
        	vm = this;
        	vm.languageColumn = Language.getActiveColumn();
        	vm.signProcessActions = SignLocalFactory.signProcessActionsToAssistent;
        	vm.userPositions = (($rootScope.LoggedUser && $rootScope.LoggedUser.userPositions)?$linq($rootScope.LoggedUser.userPositions).select("x => x.position").toArray():[]);
        	vm.isValidateSign = function (signProcessAction){
        		if(signProcessAction && signProcessAction.signActionType && signProcessAction.signActionType.code && signProcessAction.signActionType.code == apiSign.VALIDATE_CODE){
        			vm.isValidation = true;
        		}else{
        			vm.isValidation = false;
        		}
        	};
        	vm.getDocument = function(signProcessAction){
        		if(signProcessAction && signProcessAction.signProcess && signProcessAction.signProcess.document && signProcessAction.signProcess.document.id){
        			if(vm.signProcessActionActual.signProcess.document.id != signProcessAction.signProcess.document.id){
        				$state.transitionTo('annexa.sign.assistent', {
                            "code": signProcessAction.signProcess.document.id
                        });
        			}else{
        				vm.getPositionSignProcess(signProcessAction.signProcess.document.id);
        			}
    			}else{
    				DialogsFactory.error($filter('translate')('global.errors.errorSignProcessActionActual'), $filter('translate')('DIALOGS_ERROR_MSG'));
            		$state.go('annexa.sign.pending');
    			}
        	};
        	vm.onUserPositionQueuedSelected = function(){
            	if(vm.signProcessActionActual && vm.datatableQueuedPositions && vm.datatableQueuedPositions.value){
            		SignService.updatePosition(vm.signProcessActionActual.id, vm.datatableQueuedPositions.value).then(function(dataUpdate){
            			if(vm.delegateModal && vm.delegateModal.activeRebudes == true 
            					&& vm.delegateModal.delegacionsRebudes && vm.delegateModal.delegacionsRebudes.length > 0) {
            				if(vm.signProcessActionActual.userMustSign && vm.signProcessActionActual.userMustSign.id && $rootScope.LoggedUser && $rootScope.LoggedUser.id != vm.signProcessActionActual.userMustSign.id) {
            					var deleg = $linq(vm.delegateModal.delegacionsRebudes).firstOrDefault(undefined, "x=>x.delegatorUser && x.delegatorUser.id =="+vm.signProcessActionActual.userMustSign.id);
                				if(deleg) {
                					deleg.position = undefined;
                				}
            				}
            			}
                    });
            	}
            };
        	vm.getReject = function() {
        		var modal = angular.copy(globalModals.rejectSignInAssistent);
	            modal.annexaFormly.model = {};
	            modal.annexaFormly.options = {};
	            modal.submitLabel = 'global.sign.literals.rejectSign';
	            modal.submitClass = 'grey';
				var submitRejectSign = function(){
					 var modal = this;
		            if(vm.signProcessActionActual && vm.signProcessActionActual.signProcess && vm.signProcessActionActual.signProcess.document && vm.signProcessActionActual.signProcess.document.id && modal &&  modal.annexaFormly && modal.annexaFormly.model && modal.annexaFormly.model.modal_body && modal.annexaFormly.model.modal_body.reason) {
		            	SignService.rejectSign(vm.signProcessActionActual, vm.signProcessActionActual.signProcess.document.id, modal.annexaFormly.model.modal_body.reason).then(function(ret){
		                    modal.close();
		            		if(ret){
		                    	vm.getNextPositionSignProcess("next");
		                    }
		                }).catch(function(error){
		                	if(error && error == 'No comment in reject'){
								DialogsFactory.error($filter('translate')('global.errors.rejectReasonRequired'));
							}else if(error && error.message && error.message == 'Error book state modify'){
		                		DialogsFactory.error($filter('translate')('global.errors.errorCancelBookState'));
		                	}else if(error && error.message && error.message == 'Error document status is not correct'){
		                		DialogsFactory.error($filter('translate')('global.errors.errorCancelDocumentState'));
		                	}else{
		                		DialogsFactory.error($filter('translate')('global.errors.errorCancelSign')); 
		                	}
		                	modal.close();
		                });
		            }
				}
	            AnnexaFormlyFactory.showModal('modalRejectSign', modal, submitRejectSign, false);
        		
        	};
        	vm.getValidate = function() {
        		var modal = angular.copy(globalModals.validateSignInAssistent);
	            modal.annexaFormly.model = {};
	            modal.annexaFormly.options = {};
	            modal.submitLabel = 'global.sign.literals.validateSign';
	            modal.submitClass = 'grey';
				var submitValidateSign = function(){
					 var modal = this;
		            if(vm.signProcessActionActual && vm.signProcessActionActual.signProcess && vm.signProcessActionActual.signProcess.document && vm.signProcessActionActual.signProcess.document.id) {
		            	SignService.validateSign(vm.signProcessActionActual, vm.signProcessActionActual.signProcess.document.id).then(function(ret){
		            		modal.close();
		            		vm.getNextPositionSignProcess("next");
		                }).catch(function(error){
		                	if(error && error.message && error.message == 'Error book state modify'){
		                		DialogsFactory.error($filter('translate')('global.errors.errorCancelBookState'));
		                	}else{
		                		DialogsFactory.error($filter('translate')('global.errors.errorValidateSign')); 
		                	}
		                	modal.close();
		                });
		            }
				}
	            AnnexaFormlyFactory.showModal('modalValidateSign', modal, submitValidateSign, false);
        	};
        	vm.getAddToSign = function() {
        		var isInTableQueued = $linq(vm.tableQueued.list).contains(vm.signProcessActionActual,"(x, y) => x.id == y.id");
                if(!isInTableQueued){
                	var addToSignOk = function(id, position){
	                    SignService.addToSign(id, position).then(function(dataUpdate){
	                        vm.tableQueued.list.push(vm.signProcessActionActual);
	                        vm.getNextPositionSignProcess("next");
	                    });
                	}
                	if(vm.datatableQueuedPositions && vm.datatableQueuedPositions.value) {
                		addToSignOk(vm.signProcessActionActual.id, vm.datatableQueuedPositions.value);
                	}else if(vm.signProcessActionActual && vm.signProcessActionActual.userPosition && vm.signProcessActionActual.userPosition.id) {
                		addToSignOk(vm.signProcessActionActual.id, vm.signProcessActionActual.userPosition.id);
                	}else if(vm.delegateModal && vm.delegateModal.activeRebudes == true && vm.signProcessActionActual.userMustSign && vm.signProcessActionActual.userMustSign.id && $rootScope.LoggedUser && $rootScope.LoggedUser.id != vm.signProcessActionActual.userMustSign.id){
                		var deleg = undefined;
                		if(vm.delegateModal && vm.delegateModal.delegacionsRebudes){
                			deleg = $linq(vm.delegateModal.delegacionsRebudes).firstOrDefault(undefined, "x=>x.delegatorUser && x.delegatorUser.id =="+vm.signProcessActionActual.userMustSign.id);
                		}
                		if(deleg && (deleg.position || !deleg.positions || deleg.positions.length == 0)){
                    		addToSignOk(vm.signProcessActionActual.id, deleg.position)
                    	}else{
                    		DialogsFactory.confirm('global.literals.confirmPositionSignTitle', 'global.literals.confirmPositionSignBody').then(function (data) {
                    			addToSignOk(vm.signProcessActionActual.id, undefined);
       						}).catch(function (error) {});
                    	}
                	}else{
                		DialogsFactory.confirm('global.literals.confirmPositionSignTitle', 'global.literals.confirmPositionSignBody').then(function (data) {
                			addToSignOk(vm.signProcessActionActual.id, undefined)
   						}).catch(function (error) {});
                	}
                }
        	};
        	vm.getNextPositionSignProcess = function(position) {
        		if(position == "first"){
        			$rootScope.$broadcast('positionSignAssistent', { spaActual: vm.signProcessActions[0]});
        			vm.getDocument(vm.signProcessActions[0]);
        		}else if(position == "next"){
        			vm.indexSpa = vm.signProcessActions.indexOf(vm.signProcessActionActual);
        			$rootScope.$broadcast('positionSignAssistent', { spaActual: vm.signProcessActions[vm.indexSpa + 1]});
            		vm.getDocument(vm.signProcessActions[vm.indexSpa + 1]);
        		}else if(position == "previous"){
        			vm.indexSpa = vm.signProcessActions.indexOf(vm.signProcessActionActual);
        			$rootScope.$broadcast('positionSignAssistent', { spaActual: vm.signProcessActions[vm.indexSpa - 1]});
            		vm.getDocument(vm.signProcessActions[vm.indexSpa - 1]);
        		}else{
        			$rootScope.$broadcast('positionSignAssistent', { spaActual: vm.signProcessActions[vm.signProcessActions.length - 1]});
        			vm.getDocument(vm.signProcessActions[vm.signProcessActions.length - 1]);
        		}
        		
        	};
        	vm.getPositionSignProcess = function(idDocument){
        		if(SignLocalFactory.spaAssistentActual){
        			vm.signProcessActionActual = $linq(vm.signProcessActions).firstOrDefault(undefined,"x => x.id == "+SignLocalFactory.spaAssistentActual.id);
        		}else{
        			vm.signProcessActionActual = $linq(vm.signProcessActions).firstOrDefault(undefined,"x => x.signProcess.document.id == "+idDocument);
        		}
        		if(vm.signProcessActionActual){
        			vm.isValidateSign(vm.signProcessActionActual);
        			vm.indexSpa = vm.signProcessActions.indexOf(vm.signProcessActionActual);
        			vm.signProcessActionFirst = vm.indexSpa > 0 ? true : false;
            		vm.signProcessActionPrevious = vm.indexSpa > 0 ? true : false;
            		vm.signProcessActionLast = vm.indexSpa < vm.signProcessActions.length -1 ? true : false;
            		vm.signProcessActionNext = vm.indexSpa < vm.signProcessActions.length -1 ? true : false;
            		$rootScope.$broadcast('positionSignAssistent', { spaActual: undefined});
        		}else{
        			DialogsFactory.error($filter('translate')('global.errors.notFoundSignProcessActions'), $filter('translate')('global.sign.assistent.title'));
            		$state.go('annexa.sign.pending');
        		}
        	};
        	
        	this.$onInit = function() {
        		if(DccumentsFactory.document && vm.signProcessActions && vm.signProcessActions.length > 0){
        			vm.getPositionSignProcess(DccumentsFactory.document.id);
        			vm.datatableQueuedPositions = {};
        			if(vm.signProcessActionActual){
        				vm.datatableQueuedPositions.value = ((vm.signProcessActionActual.userPosition)?vm.signProcessActionActual.userPosition.id:undefined);
            			if(vm.signProcessActionActual && vm.signProcessActionActual.userMustSign && vm.signProcessActionActual.userMustSign.userPositions && vm.signProcessActionActual.userMustSign.userPositions.length > 0){
            				if(vm.delegateModal && vm.delegateModal.delegacionsRebudes && vm.delegateModal.delegacionsRebudes.length > 0
            						&& $linq(vm.delegateModal.delegacionsRebudes).contains(vm.signProcessActionActual.userMustSign.id, "(x, y) => x.delegatorUser && x.delegatorUser.id == y")){
            					var delegation = $linq(vm.delegateModal.delegacionsRebudes).firstOrDefault(undefined, "x => x.delegatorUser && x.delegatorUser.id == " + vm.signProcessActionActual.userMustSign.id);
            					if(delegation && delegation.delegationUserPositions && delegation.delegationUserPositions.length > 0) {
            						var delegationUserPositions = $linq(delegation.delegationUserPositions).select("x => x.userPosition").toArray();
            						vm.datatableQueuedPositions.list = $linq(delegationUserPositions).where("x => x.position").select("x => x.position").toArray();
            					} else if(delegation && delegation.delegatedUser && delegation.delegatedUser.userPositions 
            							&& delegation.delegatedUser.userPositions.length > 0) {
            						vm.datatableQueuedPositions.list = $linq(delegation.delegatedUser.userPositions).where("x => x.position").select("x => x.position").toArray();
            					}
            				} else {
            					vm.datatableQueuedPositions.list = $linq(vm.signProcessActionActual.userMustSign.userPositions).select("x => x.position").toArray();
            				}
            			}else{
            				vm.datatableQueuedPositions.list = vm.userPositions;
            			}
                    	if(vm.datatableQueuedPositions.list && vm.datatableQueuedPositions.list.length > 0){
                    		if(vm.datatableQueuedPositions.list.length == 1 && !vm.datatableQueuedPositions.value 
                    				&& $rootScope && $rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.sign_util_configuration
                    				&& $rootScope.app.configuration.sign_util_configuration && $rootScope.app.configuration.sign_util_configuration.whenOnePositionSelectDefault
                    				&& $rootScope.app.configuration.sign_util_configuration.whenOnePositionSelectDefault == 'true'){
                    			vm.datatableQueuedPositions.value = vm.datatableQueuedPositions.list[0].id
                    		}
                    	}
        			}
        		}else if(!vm.signProcessActions || (vm.signProcessActions && vm.signProcessActions.length == 0)){
        			DialogsFactory.notify($filter('translate')('global.sign.assistent.no_results'), $filter('translate')('global.sign.assistent.title'));
            		$state.go('annexa.sign.pending');
        		}
        	}
        }],
        bindings: {
            delegateModal: '=',
            tableQueued: '='
        }
    });